export class AuthConfig {
  public auth_config: {
    allowed_cors_orgins;
    application_type: string;
    jwt_expiration: Number;
    logo: string;
    logout_url: string;
    return_url: string;
    updated_by: string;
    application_name: string;
  };
  public samlConfig: {
    provider?: string;
    idp_issuer?: string;
    sso_url?: string;
    nameid_format?: string;
    saml_assertion?: boolean;
    recipient?: string;
    audience_uri?: string;
    destination_url?: string;
    idp_sso_url?: string;
    relay_state?: string;
    identityProviderIssuer?: string;
    provisioning:string;
  };
  urlInvalid: UrlConfig;
  public certificate: string;
  public provisioning:string;
  /**
   *
   */
  constructor() {
    this.urlInvalid = new UrlConfig();

  }
}

export class UrlConfig {
  public active: boolean;
  public main_redirect_url: string;
  constructor() {
  }
}
